import React, { useEffect, useState } from "react";
import { IConfig } from "../utils/IConfig";
import { loadConfig } from "../utils/IConfigUtils";
import { generateArtworkDataUrl } from "./Bottom/Footer/delegate";
import { useTranslation } from "react-i18next";
import { Vizualization } from "./Vizualization";
import { Palette } from "./Palette";
import { Shapes } from "./Shapes";
import { ShapePosition } from "./ShapePosition";
import "./remoteDownload.css"; 
import Header from './Top/Header/Header';
import Footer from './Bottom/Footer/Footer';

const queryParams = new URLSearchParams(window.location.search);

export interface IRemoteDownloadParams {
    palette: Palette;
    shapes: Shapes;
    selectedShape: number;
    shapeColors: string[];
    stripesWidth: number;
    shapePositions: ShapePosition[];
    anyAction: boolean;
}

function RemoteDownload(remoteDownloadParams: IRemoteDownloadParams) {
    const { t } = useTranslation();
    const config: IConfig = loadConfig();
    const [imgData, setImgData] = useState<string | null>(null);

    useEffect(() => {
        setTimeout(async () => {
            const url = await generateArtworkDataUrl();
            setImgData(url);
        }, 500);
    }, []);
    
    const getLogoUrl = (qp: URLSearchParams): string => {
        let logo = qp.get("logoUrl") as string;
        if(logo) {
            return `assets/clientImg/${logo}`;
        }
        return `assets/clientImg/${config.application.folderName}/${config.application.logoPdfFileName}`;
    }
    const logoUrl = getLogoUrl(queryParams);

    if (imgData) {
        return (
            <div className="App" style={{ height: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center', backgroundColor: '#fff', overflowY: 'auto' }}>
                <div style={{ padding: '20px', width: '100%', display: 'flex', justifyContent: 'center' }}>
                    <p style={{textAlign: 'center', margin: 0, fontSize: '18px', color: '#333'}}>Przytrzymaj palec na obrazku, aby go zapisać</p>
                </div>
                <div style={{ flex: 1, display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', padding: '0 20px' }}>
                    <img src={imgData} alt="Generated Artwork" style={{ maxWidth: '100%', maxHeight: '70vh', objectFit: 'contain', boxShadow: '0px 0px 20px rgba(0,0,0,0.1)' }} />
                </div>
                <div style={{ padding: '20px', width: '100%', display: 'flex', justifyContent: 'center', marginBottom: '30px' }}>
                    <button
                        className="intro__button"
                        style={{ fontSize: '18px', padding: '15px 30px', cursor: 'pointer' }}
                        onClick={() => {
                            if (navigator.share) {
                                fetch(imgData).then(res => res.blob()).then(blob => {
                                    const file = new File([blob], 'cruz-diez-artwork.jpg', { type: 'image/jpeg' });
                                    navigator.share({
                                        title: 'Cruz Diez Artwork',
                                        files: [file]
                                    }).catch(console.error);
                                });
                            } else {
                                const link = document.createElement('a');
                                link.download = 'cruz-diez-artwork.jpg';
                                link.href = imgData;
                                link.click();
                            }
                        }}>
                        Udostępnij (Share)
                    </button>
                </div>
            </div>
        );
    }

    return (
        <div className="App App--print" style={{ overflowY: 'hidden', height: '100vh', padding: '20px' }}>
            <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(255,255,255,0.9)', zIndex: 9999, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <h2>Generowanie obrazu...</h2>
            </div>
            <div className="App__content App__content--print" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <div className="App__content--center" style={{ width: '100%', maxWidth: '1000px' }}>
                    <Header print={true} timer={0} textMaxLength={100} text="Just like a musical score, the interpreter enters in the language and Spirit of the artist."
                      onToggleSettingsPopUp={() => {}} />

                    <Vizualization
                        palette={remoteDownloadParams.palette} shapes={remoteDownloadParams.shapes} selectedShape={remoteDownloadParams.selectedShape} shapeColors={remoteDownloadParams.shapeColors}
                        stripesWidth={remoteDownloadParams.stripesWidth} shapePositions={remoteDownloadParams.shapePositions} anyAction={remoteDownloadParams.anyAction}
                        onStripeChanged={() => {}}
                        onShapePositionChange={() => {}}
                    />

                    <Footer shapePalette={[]} selectedStripe={-1} shapeColors={remoteDownloadParams.shapeColors} palette={remoteDownloadParams.palette} selectedShape={-1} shapes={remoteDownloadParams.shapes} shapePositions={remoteDownloadParams.shapePositions}
                      shapeRotationDegree={{left: 0, right: 0}} maxShapeRotationDegree={360} stripesWidth={remoteDownloadParams.stripesWidth} colors={[]} print={true}
                      showQrCode={() => {}}
                      onStripeChanged={() => {}}
                      onToggleSettingsPopUp={() => {}}
                      stopTimer={() => {}}
                      logoUrl={logoUrl}
                      onColorChanged={() => {}}
                      onShapeSelect={() => {}}
                      onShapeChange={() => {}}
                      onShapeHidden={() => {}}
                      onRotationChange={() => {}}
                      onResetToDefault={() => {}}
                      onDemoInstructionsToggle={() => {}}
                      onToggleSharePopUp={() => {}}
                    />
                </div>
            </div>
        </div>
    );
}

export default RemoteDownload;